var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "m-0 document-type-list" }, [
    _c(
      "div",
      { staticClass: "collapse-m-header border-bottom py-0" },
      [
        _c("document-request-list-header", {
          attrs: {
            "document-request": _vm.documentRequest,
            "document-request-list-name": _vm.documentRequestListName,
            "has-sample-documents": _vm.hasSampleDocuments,
            visible: _vm.collapseVisible,
          },
        }),
        _vm._v(" "),
        _vm.hasSampleDocuments
          ? _c(
              "b-collapse",
              {
                attrs: { id: _vm.documentRequest.id },
                model: {
                  value: _vm.collapseVisible,
                  callback: function ($$v) {
                    _vm.collapseVisible = $$v
                  },
                  expression: "collapseVisible",
                },
              },
              [
                _c("document-request-list-body", {
                  attrs: {
                    "has-sample-documents": _vm.hasSampleDocuments,
                    "sample-documents": _vm.sampleDocuments,
                    "application-id": _vm.applicationId,
                    "client-username": _vm.clientUsername,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }